module.exports = __webpack_public_path__ + "static/media/iconfont.8c34e38e.woff";